module["exports"] = [
  "Norte",
  "Este",
  "Sul",
  "Oeste",
  "Nordeste",
  "Noroeste",
  "Sudeste",
  "Sodoeste"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_PT/address/direction.js
// module id = 3424
// module chunks = 1610